import { useState, useEffect, useCallback } from 'react';
import _ from 'lodash';
import Logger from '@medflex/utils/Logger';
import config from '@medflex/utils/config';

export const BREAKPOINTS = {
  XS: 0,
  SM: 480,
  LG: 912,
  XL: 1280,
};

const useScreenSize = () => {
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);

  const onWindowResize = useCallback(() => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);

    if (config.DEBUG === '1') {
      Logger.log(`[resizeWindow] width: ${window.innerWidth}, height: ${window.innerHeight}`);
    }
  }, []);

  useEffect(() => {
    const throttledVersion = _.throttle(onWindowResize, 300);
    window.addEventListener('resize', throttledVersion);
    return () => window.removeEventListener('resize', throttledVersion);
  }, [onWindowResize]);

  return { width, height };
};

export default useScreenSize;
